angular.module('hcap-analytics')
.controller('CsmCohortsCtrl', [
  '$scope',
  'CohortsService',
  '$uibModal',
  '$state',
function(
  $scope,
  CohortsService,
  $uibModal,
  $state,
) {
  const portal = $state.params.portal;

  $scope.portal = portal;
  $scope.data = {
    cohorts: [],
    introHide: true,
  };

  const setup = force => {
    return CohortsService.getByPortal(portal, force).then(cohorts => {
      $scope.data.cohorts = cohorts;
    });
  };

  setup();

  $scope.onDelete = cid => {
    return CohortsService.deleteCohort(cid).then(() => {
      return setup();
    });
  };

  $scope.onUpdate = cid => {
    const cohort = _.cloneDeep($scope.data.cohorts.find(c => c._id === cid));
    const onDelete = $scope.onDelete;

    $uibModal.open({
      templateUrl: 'templates/partials/_updateCohort.html',
      controller: ['$uibModalInstance', '$scope', ($uibModalInstance, $scope) => {
        $scope.data = {
          form: null,
          cohort,
        };

        $scope.data.cohort.bundleGuid = $scope.data.cohort.bundleGuid || null;

        $scope.submit = () => {
          if ($scope.data.form.$valid) {
            $scope.data.form.$setSubmitted();

            CohortsService.updateCohort(cohort).then(() => {
              setup();
              $uibModalInstance.close();
            });
          } else {
            document.querySelector('input').reportValidity();
          }
        };

        $scope.deleteCohort = () => {
          onDelete(cid).then($uibModalInstance.close);
        };

        $scope.close = () => {
          $uibModalInstance.dismiss('cancel');
        };
      }],
    });
  };

  $scope.toggleIntro = () => {
    $scope.data.introHide = !$scope.data.introHide;
  };

}]);
